import { useQuery } from '@tanstack/react-query';

import { type OpenPublishTargets, publishService } from '@/services/data/PublishService';

const CHECK_REFRESH_MS = 60_000;
const NONE: OpenPublishTargets = { unresolved: [], owedPlatforms: [] };

/**
 * The targets of a post that may be live and that only a provider check or the author can settle
 * (`shared/provider-outcome.ts`), and the platforms still owed a send. Refreshes while a check is running, so the editor
 * shows the answer when it lands.
 */
export function useUnresolvedPublishTargets(
  postId: string | null | undefined,
  enabled: boolean,
): OpenPublishTargets {
  const query = useQuery({
    queryKey: ['post-open-targets', postId ?? null],
    enabled: Boolean(postId && enabled),
    queryFn: async () => {
      const response = await publishService.getOpenTargets(postId as string);
      if (response.error) throw new Error(response.error.message);
      return response.data ?? NONE;
    },
    refetchInterval: (current) =>
      current.state.data?.unresolved.some(
        (target) => target.deliveryStatus === 'native_status_unknown',
      )
        ? CHECK_REFRESH_MS
        : false,
  });
  return query.data ?? NONE;
}
